import { mesParaAbreviacao } from './mesParaAbreviacao';

/**
 * Transforma a data de competência para o formato `Aaa 000`
 *
 * @param competencia Data de competência no formato `yyyy-mm`
 * @returns Data de competência no formato `Aaa 000`,
 *   retorna o próprio parâmetro `competencia` caso inválido
 */
export function formatarCompetencia(competencia: string) {
  const regexCompetencia = /^\d{4}-\d{2}$/;

  if (!regexCompetencia.test(competencia)) {
    return competencia;
  }

  // Divide a string em ano e mês
  const [ano, mes] = competencia.split('-');

  //Obtém mês abreviado
  const mesAbreviado = mesParaAbreviacao(Number(mes));

  const mesFormatado = mesAbreviado.charAt(0).toUpperCase() + mesAbreviado.slice(1).toLowerCase();

  return `${mesFormatado}/${ano}`;
}

/**
 * Transforma mes e ano decompetência para o formato `AAA/yyyy`
 *
 * @param mesCompetencia mes da competência `0`,
 * @param anoCompetencia ano da competência `0000`,
 * @returns Data de competência no formato `AAA/0000`,
 *   retorna '' caso inválido
 */
export function formatarCompetenciaPorMesEAno(mesCompetencia: number, anoCompetencia: number) {
  //Obtém mês abreviado
  if (mesCompetencia <= 0 || anoCompetencia <= 0) return '';

  const mesAbreviado = mesParaAbreviacao(Number(mesCompetencia));

  const mesFormatado = mesAbreviado.charAt(0).toUpperCase() + mesAbreviado.slice(1).toLowerCase();

  return `${mesFormatado}/${anoCompetencia}`;
}

/**
 * Transforma a data de competência no padrão `MONTH/YYYY` para o formato `YYYY-MM-01`
 *
 * @param competencia Data de competência no formato `MONTH/YYYY`
 * @returns Data de competência no formato `YYYY-MM-01`,
 */

export function converterCompetenciaParaISO(competencia: string) {
  const nomeMeses: { [key: string]: string } = {
    JANEIRO: '01',
    FEVEREIRO: '02',
    MARÇO: '03',
    ABRIL: '04',
    MAIO: '05',
    JUNHO: '06',
    JULHO: '07',
    AGOSTO: '08',
    SETEMBRO: '09',
    OUTUBRO: '10',
    NOVEMBRO: '11',
    DEZEMBRO: '12',
  };

  // Divide a string em mês e ano
  const [mes, ano] = competencia.split('/');

  return `${ano}-${nomeMeses[mes.toUpperCase()]}-01`;
}
